import React from 'react'
import { Helmet } from 'react-helmet'
import PageTitle from './../../Components/PageTitle/PageTitle.jsx';
import style from './Resume.module.css'
import SkillsList from '../../Components/SkillsList/SkillsList.jsx';
import JobList from '../../Components/JobList/JobList.jsx';

export default function Resume() {

    return (
        <div>
            <Helmet>
                <title>Resume Hossam</title>
            </Helmet>
            <PageTitle title="Resume" />


            {/* Education */}
            <div className={`mt-4 ${style.line} flex flex-col gap-5`}>
                <div className='flex flex-row items-center gap-4 text-[#19284D] font-semibold text-xl'>
                    <div className='bg-[#E8EBF0] rounded-md h-[3rem] w-[3rem] flex items-center justify-center'>{educationIcon}</div>
                    Education
                </div>

                <div className={`${style.point} ml-[4.1rem] `}>
                    <h4 className='text-[#19284D] font-medium text-lg'>Ain Shams University</h4>
                    <p className='text-[#0369E4]'>2020 - 2024</p>
                    <p className='text-[#2f4e80]'>
                        Computer Science Department, <br />
                        Faculty of Computer and Information Science
                    </p>
                    <p className='text-[#0369E4]'>GPA: 3.3, B+</p>
                </div>
                
            </div>

            {/* Experience */}
            <div className={`mt-10 ${style.line} flex flex-col gap-6`}>
                <div className='flex flex-row items-center gap-4 text-[#19284D] font-semibold text-xl'>
                    <div className='bg-[#E8EBF0] rounded-md h-[3rem] w-[3rem] flex items-center justify-center'>{workIcon}</div>
                    Experience
                </div>

                <JobList />

            </div>


            {/* Skills */}
            <div className='mt-16'>
                <h3 className='text-[#19284D] font-semibold text-3xl text-center'>My Skills</h3>
                <SkillsList />
            </div>

        </div>
    )
}




const educationIcon = <svg width="32" height="23" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 0L0 6.90243L5.45455 9.41032V16.3127L15 20.7073L24.5455 16.3127V9.41032L27.2727 8.15637V16.1057H30V6.90243L15 0ZM24.3 6.90243L15 11.1819L5.7 6.90243L15 2.62292L24.3 6.90243ZM21.8182 14.9553L15 18.0844L8.18182 14.9553V10.6643L15 13.8049L21.8182 10.6643V14.9553Z" fill="#2184E3" />
</svg>


const workIcon = <svg width="29" height="22" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27 2.89981V17.3941H0V2.89981H8.4375V1.45038C8.4375 1.24655 8.48145 1.05782 8.56934 0.884191C8.65723 0.710561 8.77588 0.559579 8.92529 0.431244C9.07471 0.302909 9.25488 0.197221 9.46582 0.114181C9.67676 0.0311401 9.89648 -0.00660548 10.125 0.000943641H16.875C17.1123 0.000943641 17.332 0.0386893 17.5342 0.114181C17.7363 0.189672 17.9121 0.291585 18.0615 0.41992C18.2109 0.548255 18.334 0.703012 18.4307 0.884191C18.5273 1.06537 18.5713 1.2541 18.5625 1.45038V2.89981H27ZM10.125 2.89981H16.875V1.45038H10.125V2.89981ZM1.6875 4.34924V6.44412L10.125 10.0564V8.69754H16.875V10.0564L25.3125 6.44412V4.34924H1.6875ZM11.8125 10.147V11.5964H15.1875V10.147H11.8125ZM25.3125 15.9447V8.05208L16.875 11.687V13.0458H10.125V11.687L1.6875 8.05208V15.9447H25.3125Z" fill="#2184E3" />
</svg>
